.link {
  display: flex;
  gap: 0.5rem;
}
